import type { IntlShape } from '@liveauctioneers/hammer-ui-core/intl';

import { toast } from '@liveauctioneers/hammer-ui-core/toast';

/**
 * For callers outside a component that receive `formatMessage` as an argument; components get the
 * same toast from `useSubmitSaveSearch`.
 */
export const showInvalidFacetsToast = (formatMessage: IntlShape['formatMessage']) => {
    toast('error', {
        description: formatMessage({ id: 'toastMessages.descriptions.searchNotSavedInvalidFilters' }),
        title: formatMessage({ id: 'toastMessages.titles.searchNotSaved' }),
    });
};
